import React, { FunctionComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { Field, FormikErrors, FormikValues } from "formik";
import RadioButton from "../../../shared/publicForms/RadioButton";
import TextField from "../../../shared/publicForms/TextField";
import {
  RadioButtonGroupWrapper,
  RadioButtonGroup,
} from "../../styles/diversity-form-styles";

export interface IEthnicityProps {
  values: {
    ethnicGroup?: null | string;
    ethnicSubgroup?: null | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
}

const Mixed: FunctionComponent<IEthnicityProps> = ({
  values,
  setFieldValue,
}) => {
  const radioButtonOptions = [
    null,
    "Mixed - White and Asian",
    "Mixed - White and Black African",
    "Mixed - White and Black Caribbean",
    "Mixed - Other",
  ];
  const { ethnicSubgroup } = values;

  return (
    <RadioButtonGroupWrapper
      role="group"
      marginTop={22}
      aria-labelledby="ethnicity-radio-group"
    >
      <RadioButtonGroup width={330}>
        {radioButtonOptions
          .filter((option) => option)
          .map((option) =>
            option === "Mixed - Other" ? (
              <Fragment key={option}>
                <Field
                  name="ethnicSubgroup"
                  type="radio"
                  aria-label={option}
                  label={option}
                  value={option}
                  onChange={() => setFieldValue("ethnicSubgroup", "", true)}
                  checked={!radioButtonOptions.includes(ethnicSubgroup)}
                  as={RadioButton}
                />
                {!radioButtonOptions.includes(ethnicSubgroup) && (
                  <Field
                    name="ethnicSubgroup"
                    type="text"
                    aria-label={ethnicSubgroup}
                    placeholder="Please specify"
                    as={TextField}
                  />
                )}
              </Fragment>
            ) : (
              <Field
                key={option}
                name="ethnicSubgroup"
                type="radio"
                aria-label={option}
                label={option}
                value={option}
                as={RadioButton}
              />
            )
          )}
      </RadioButtonGroup>
    </RadioButtonGroupWrapper>
  );
};

Mixed.propTypes = {
  values: PropTypes.shape({
    ethnicGroup: PropTypes.string,
    ethnicSubgroup: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    ethnicGroup: PropTypes.string,
    ethnicSubgroup: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default Mixed;
